// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preferencesControl_preferencesControl__3utgX {\n  width: 65%;\n}\n.preferencesControl_preferencesControl__3utgX label {\n  text-transform: uppercase;\n}\n.preferencesControl_preferencesControl__3utgX > div {\n  display: flex;\n  justify-content: space-between;\n  margin: 1rem;\n}", ""]);
// Exports
exports.locals = {
	"preferencesControl": "preferencesControl_preferencesControl__3utgX"
};
module.exports = exports;
